import { CustomButton } from './custombutton';

/**
 * @deprecated use BX.UI.Button
 */
export class PopupWindowCustomButton extends CustomButton
{
	// No additional functionality, just for compatibility
}
